import { from } from 'rxjs';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import DataGrid from "devextreme/ui/data_grid";
import { ToastService } from 'ng-uikit-pro-standard';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxTreeViewComponent } from 'devextreme-angular';
import { TaskService } from 'src/app/services/task.service';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { GeneralService } from 'src/app/services/general.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ProjectService } from 'src/app/services/project.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppConfigService } from 'src/app/app-config.service.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { CreateUpdateTaskComponent } from '../create-update-task/create-update-task.component';
import { Component, OnInit, SimpleChanges, ViewContainerRef, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;

type AOA = any[][];
@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild("gridfile", { static: false }) gridfile: DxDataGridComponent;
  @ViewChild("gridFileSummary", { static: false }) gridFileSummary: DxDataGridComponent;
  @ViewChild('GridTasks', { static: false }) TasksGrid: DxDataGridComponent;
  @ViewChild('SummaryTaskGrid', { static: false }) SummaryTaskGrid: DxDataGridComponent;
  @ViewChild('memorizeGrid', { static: false }) MemorizeTasksGrid: DxDataGridComponent;

  @Input() parentProjectId: number;
  @Input() offsetHeight: any = 0;
  @Input() expandpopup: boolean;
  @Output() onOpenFullScreen = new EventEmitter<any>();;

  cancelButtonSummary: any;
  saveButtonSummary: any;

  customer: any;
  now = new Date();
  tooltip: any;
  popupTask = false;
  popupSummaryTask = false;
  popupDeleteSummaryTask = false;
  popupGridSummaryTask = false;
  popupImportMemorizedTask = false;
  serviceresourcesText = '';
  selectedRows = false;
  private _project: any;

  dateFormat = '';

  @Input('project')
  set project(project: any) {
    project.projectname = project.projectid + '-' + project.projectname;
    this._project = project;
  }

  get project(): any { return this._project; }

  filterPagedTask = {
    pageindex: 1,
    pagesize: 20,
    orderid: 1,
    summarytaskid: 0,
    projectnumber: '',
    taskname: '',
    responsiblesids: '',
    statusids: '',
    categoryids: '',
    duedate: '',
    taskid: 0,
    projectname: '',
    resourceids: '',
    priorityids: '',
    phaseids: '',
    projectid: 0
  };
  salesCategorySelect: any = [];
  categorySelect: any = [];
  statusSelect: any = [];
  prioritySelect: any = [];
  employeeSelect: any = [];
  phasesSelect: any = [];
  projectlist: any;
  updateProjectInfoName: any;
  projectslist: any;

  taskDataSource: any = [];

  taskresourcesText: string;
  taskresourcesValues = [];

  taskstatusValues = [];
  taskstatusText: string;

  //Task
  selectedTaskId: any;
  showpopupDeleteTask: boolean = false;
  showpopupDuplicateTask: boolean = false;
  filterValue: Array<any>;

  categoriesValues = [];
  categoriesText: string;

  responsibleText: string;
  taskresponsiblesValues = [];

  resourcesValues = [];
  resourcesText: string;

  public _formEntity: FormGroup;
  _formSummary: FormGroup = new FormGroup({
    id: new FormControl({ value: 0, disabled: false }, []),
    sort: new FormControl({ value: 0, disabled: false }, []),
    name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    projectid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
    startdate: new FormControl({ value: null, disabled: false }, []),
    duedate: new FormControl({ value: null, disabled: false }, []),
    completionperc: new FormControl({ value: 0, disabled: false }, []),
    notes: new FormControl({ value: '', disabled: false }, []),
  });
  summaryTask = [];
  loading = false;
  summaryToDeleteId = null;

  dsPagedTask: any;
  percent = 0;
  _formNewTask: FormGroup;
  locationSelect: any;

  projectInfoModel = {
    projectid: 0,
    projectname: '',
    projectnumber: ''
  };

  items = [
    {
      id: 1,
      name: 'Summary Task',
    },
    {
      id: 2,
      name: 'Task',
    },
    {
      id: 4,
      name: 'Import Task from Excel',
    },
    {
      id: 5,
      name: 'Import Summary Task from Excel',
    },
    {
      id: 3,
      name: 'Import Task from Memorized Task',
    },
    {
      id: 6,
      name: 'Import Summary Task from Memorized Task',
    },
  ];

  taskFilters: any = {};
  rowSelected: any;

  //Multiple   Edit Tasks
  rowSelectedTask: any;
  popupEditTask: any;

  employees: any;
  categories: any;
  resources: any;
  priorities: any;
  status: any;
  editTasks: FormGroup;

  cancelButtonTasK: any;
  saveButtonTasK: any;
  saveNewButtonTasK: any;
  saveEditButtonTasK: any;
  @ViewChild('newtask', { static: false }) newtask: CreateUpdateTaskComponent;
  settings: any = {};

  //Inputs date
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today = new Date().getTime();
  startDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  dueDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };

  task: any = {
    taskid: '', name: '', projectid: '', employeeid: '', taskresources: '',
    statusid: '', todocategoryid: '', priorityid: '', area: '', phaseid: '', estimatedcost: '',
    startdate: '', estimatedtime: '', duedate: '', completionperc: '', completiondate: '',
    notes: '', sort: '', locationid: '', vendorid: '', SUMMARYTASKID: '',
    resources: '', createon: ''
  }

  //Memorize Task
  popupMemorizedTask: boolean = false;
  dataSummaryMemorizeTask: any = [];
  dataMemorizeTask: any = [];
  acordionClass = '';
  gridClass = '';
  popupNewSummaryMemorize: boolean = false;
  formSummaryMemorize: FormGroup;
  cancelButtonSummaryMemorize: any;
  saveButtonSummaryMemorize: any;

  popupNewTaskMemorize: boolean = false;
  formTaskMemorize: FormGroup;
  cancelButtonMemorizeTasK: any;
  saveButtonMemorizeTasK: any;

  cancelButtonImportMemorizeTasK: any;
  saveButtonImportMemorizeTasK: any;
  disableImport: boolean = true;
  rowSelectedMemorizeTasks: any = [];
  categoriesMemorize: any;

  showpopupDeleteMultipleTask: boolean = false;
  // expandpopup: boolean = false;

  popupFilter: boolean = false;
  cancelButtonFilter: any;
  saveButtonFilter: any;

  FiltrosTasks: FormGroup = new FormGroup({
    taskid: new FormControl('', []),
    statuses: new FormControl([1, 2], []),
    method: new FormControl('Get_Task_Paged', []),
  });

  statuses: any = [1, 2];

  //FullScreen Task Grid
  @ViewChild("originalContainer", { read: ViewContainerRef, static: false }) originalContainer: ViewContainerRef;
  @ViewChild("contenedorPopup", { read: ViewContainerRef, static: false }) contenedorPopup: ViewContainerRef;
  @ViewChild("templateTask", { static: false }) tref: TemplateRef<any>;

  showGallery: boolean = false;
  imagesGallery: any = [];

  imagenFullScreen: any;
  openModalFullScreen: boolean = false;

  methodGetDocument = { method: 'Get_ProjectTodo_DocumentsCE', name_id: 'projecttodoid' };
  selectedTaskGallery: any = {};

  //Import Task from Excel 
  popupImportFromExcel: boolean = false;
  valueDocument: any[] = [];
  dataFormatted = { headers: [], data: [] };
  fileData: any[][] = [];

  //import Summary from Excel
  popupImportSummaryFromExcel: boolean = false;
  actualState: any = 0;
  gridId: any = "TasksListStorage3";

  constructor(
    private router: Router,
    private pipeDate: DatePipe,
    private toast: ToastService,
    private taskService: TaskService,
    private translate: TranslateService,
    public generalService: GeneralService,
    private ProjectService: ProjectService,
    private loadingService: LoadingService,
    private appConfigService: AppConfigService,
    public MapInformationService: MapInformationService,
  ) {

    this.calculateSelectedRow = this.calculateSelectedRow.bind(this)
    this.customizeText = this.customizeText.bind(this);
    this.customizeText2 = this.customizeText2.bind(this);

    // botones modal new summary
    this.cancelButtonSummary = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.initFormSummaryTask();
        this.popupSummaryTask = false;
      },
    };

    this.saveButtonSummary = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveUpdateSummary()
      },
    };

    this.dateFormat = appConfigService.dateFormat;
    // this.taskFilters.moduleid = -4;

    this.settings.dateFormat = this.appConfigService.dateFormat;

    DataGrid.defaultOptions({
      device: { deviceType: "phone" },
      options: {
        columnAutoWidth: true,
        columnHidingEnabled: true,
        wordWrapEnabled: false,
        rowAlternationEnabled: false
      }
    });

    DataGrid.defaultOptions({
      device: { deviceType: "desktop" },
      options: {
        columnAutoWidth: true,
        columnHidingEnabled: false
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.project != undefined) {
      if (changes.project.previousValue !== undefined) {
        this._project = changes.project.currentValue;
        this.parentProjectId = changes.project.currentValue.projectid;
        this.ngOnInit();
      }
    }
  }

  initView() {
    // setTimeout(() => {
    //   let view = this.tref.createEmbeddedView(null);
    //   this.originalContainer.insert(view);
    //   this.expandpopup = false;
    // }, 600);
  }

  popupExpand(e) {
    this.expandpopup = e;
    this.onOpenFullScreen.emit(e)
  }

  ngOnInit() {
    this.filterPagedTask.projectid = this.parentProjectId;

    //Filtros
    let filterStorage = localStorage.getItem('filterStatus' + this.parentProjectId);
    if (filterStorage !== null) {
      this.statuses = filterStorage !== '' ? filterStorage.split(',') : [];
    }


    let filterTaskEditProject = localStorage.getItem('filterTaskEditProject' + this.parentProjectId);

    if (filterTaskEditProject !== null && filterTaskEditProject !== 'null') {
      this.filterValue = [];
      let filter = JSON.parse(filterTaskEditProject);
      filter.forEach((el, i) => {
        //Filtro de tabla cuando se escribe algo
        if ((el == 'StartDate' || el == 'DUEDATE') && filter[i + 1] !== 'anyof') {
          filter[i + 2] = new Date(filter[i + 2]);

          //Filtro de tabla cuando se elige algo desde los checkbox
        } else if ((el[0] == 'StartDate' || el == 'DUEDATE') && el[1] !== 'anyof') {
          filter[i][2] = new Date(filter[i][2]);
        }

        this.filterValue.push(el);
      });
    } else {
      this.filterValue = ["STATUSNAME", 'anyof', ['NS', 'IP']];
    }


    this.ProjectService.GetGridConfiguration(this.gridId).subscribe(result => {
      if (result && result.length != 0) {
        this.actualState = result[0];
      } else {
        this.actualState = 0;
      }
      this.actualState.FILTERCONFIG
      let finalFilter = this.actualState.FILTERCONFIG == "" || this.actualState.FILTERCONFIG == undefined ? null : JSON.parse(this.actualState.FILTERCONFIG)
      let finalColumn = this.actualState.COLUMNCONFIG == "" || this.actualState.COLUMNCONFIG == undefined ? null : JSON.parse(this.actualState.COLUMNCONFIG)

      if (finalFilter) { this.filterValue = finalFilter; }

      if (finalColumn) {
        localStorage.setItem('TasksGrid', this.actualState.COLUMNCONFIG);
        if (this.TasksGrid) { this.TasksGrid.instance.state({}); }
      }

      if (result && result.length != 0) {
        if (result[0].EXTRACONFIG) {
          if (JSON.parse(result[0].EXTRACONFIG).collased != undefined) {
            if (JSON.parse(result[0].EXTRACONFIG).collased == 1) {
              // this.closeParents()
              this.collased = true
            } else {
              // this.OpenParents()
              this.collased = false
            }
          }
        }
      }
    })

    this.cancelButtonTasK = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.newtask.rebootForm();
        this.popupTask = false;
      },
    };

    this.saveButtonTasK = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newtask.updateTask(false);
      },
    };

    this.saveNewButtonTasK = {
      text: this.translate.instant('btnSaveNew'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(true)
      },
    };

    this.saveEditButtonTasK = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(false, true)
      },
    };

    this.cancelButtonImportMemorizeTasK = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupImportMemorizedTask = false;
      },
    };

    this.saveButtonImportMemorizeTasK = {
      text: 'Import',
      icon: 'check',
      elementAttr: {
        class: 'btn-green1 btn-icon-white',
      },
      onClick: () => {

        if(this.importMemorizeTosummary){
          const dataFinal = this.MemorizeTasksGrid.instance.getSelectedRowsData()
          console.log(dataFinal)
  
          if (dataFinal.length > 0) {
            let contador = 0
            dataFinal.forEach((element, i) => {
  
              const dataToSave = {
                "method": "SaveTaskParentInfo",
                "projectid": this.parentProjectId,
                "taskname": element.NAME,
                "deleted": 0,
                "id": 0,
                "sort": element.SEQUENCE3
              }
  
              this.taskService.GeneralService(dataToSave).subscribe(result => {
                contador++
                if (contador == dataFinal.length)
                  this.toast.success(this.translate.instant('msgMemTaskImpSucc'));
                this.popupImportMemorizedTask = false;
                this.rowSelectedMemorizeTasks = [];
                this.MemorizeTasksGrid.instance.clearSelection();
                this.getTaksGrid();
              })
            });
  
          } else {
            this.toast.warning("You must select at least a registry")
          }
        } else {
          this.importMemorize();
        }

      },
    };

    this.inputsDate(this.startDate);
    this.inputsDate(this.dueDate);

    // this.getTask();
    this.getTaksGrid();
    this.initView();
  }

  inputsDate(date) {
    date.todayButton = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate += this.millisecondsInDay;
      }
    };
  }

  getTaksGrid() {
    console.log("AQUI??? ");
    let status = '';
    this.statuses !== null && this.statuses !== undefined ? status = this.statuses.toString() : '';

    this.taskService.GetTasksByProjectId(this.parentProjectId, status).subscribe(result => {
      let infoFinal = result.map(x => {
        x.taskorigin = `${x.SUMMARYTASKNAME}`
        x.SUMMARYTASKNAME = x.SUMMARYTASKNAME ? "[" + x.summ_order + '] ' + x.SUMMARYTASKID + '-' + x.SUMMARYTASKNAME : '';

        let durat = ['', ''];
        if (x.duration) {
          let stringDuration = x.duration.toString();
          stringDuration.length > 5 ? x.duration = stringDuration.substr(0, 3) + ':' + stringDuration.substr(4, 2) : '';
          durat = x.duration ? stringDuration.split('.') : ['', ''];
        }
        if (durat[1] !== undefined && durat[1] !== null) {
          durat[0] = durat[0].substr(0, 3);
          durat[1] = durat[1].substr(0, 2);
          durat[1].length == 1 ? durat[1] = durat[1] + '0' : '';
          x.duration = durat[0] + ':' + durat[1];
        } else {
          x.duration.toString().length == 2 || x.duration.toString().length == 3 ? x.duration = x.duration + ':00' : '';
          x.duration.toString().length == 1 ? x.duration = '0' + x.duration + ':00' : '';
        }

        x.duration == ':' ? x.duration = '00:00' : '';
        x.COMPLETIONPERC = x.COMPLETIONPERC * 100
        x.COMPLETIONPERC = parseInt(x.COMPLETIONPERC)

        // Actual Hours
        x.ActualHours == undefined ? x.ActualHours = '00:00' : x.ActualHour;
        x.ActualHours == "0:0" ? x.ActualHours = '00:00' : x.ActualHour;

        // x.SUMMARYTASKNAME = `${x.SUMMARYTASKNAME} (${count.length}) - `

        return x;
      });
      infoFinal.map(x => {
        let count = result.filter((y) => y.SUMMARYTASKNAME === x.SUMMARYTASKNAME)
        // console.log("🚀 ~ file: task-list.component.ts:551 ~ infoFinal ~ count:", count)
        x.TOTALSUMMARY = count.length;
        return x;
      })
      this.taskDataSource = infoFinal
      console.log("🚀 ~ file: task-list.component.ts:551 ~ this.taskService.GetTasksByProjectId ~ this.taskDataSource:", this.taskDataSource)



      // setTimeout(() => {
      //   this.TasksGrid.instance.
      // }, 1000);
    })
  }

  editTask(data) {
    let currentUrl = this.router.url.split('?')[0].split('/')[1];
    localStorage.setItem('filterTaskEditProject' + this.parentProjectId, JSON.stringify(this.filterValue));
    this.router.navigate(['taskManagement/editTask'], { queryParams: { numTODOID: data, projectId: this.parentProjectId, tab: 'Task', back: currentUrl } });
  }

  popupShowGallery(data) {
    this.selectedTaskGallery.id = data.ID;
    this.selectedTaskGallery.projectid = this._project.projectid;
    this.showGallery = true;
  }

  FirtsTime: boolean = true;

  GetFilters(data) {
    if (data.component.option("filterValue")) {
      localStorage.setItem('filterTaskEditProject' + this.parentProjectId, JSON.stringify(data.component.option("filterValue")));
    } else {
      localStorage.setItem('filterTaskEditProject' + this.parentProjectId, JSON.stringify(data.component.option("filterValue")));
      this.filterValue = []
    }

    if (this.FirtsTime) {
      if (this.collased) {
        this.closeParents()
      } else {
        this.OpenParents()
      }
      this.FirtsTime = false
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'buttonsTask'
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }

  // range slider
  format(value) {
    return value + "%";
  }

  onTooltipShown(val) {
  }

  initFormSummaryTask() {
    this._formSummary = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      projectid: new FormControl({ value: this.parentProjectId, disabled: false }, [Validators.required]),
      startdate: new FormControl({ value: null, disabled: false }, []),
      duedate: new FormControl({ value: null, disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
    })
  }

  setFormSummaryTask(item) {
    this._formSummary = new FormGroup({
      id: new FormControl({ value: item.ID, disabled: false }, []),
      sort: new FormControl({ value: item.SEQUENCE3, disabled: false }, []),
      name: new FormControl({ value: item.NAME, disabled: false }, [Validators.required]),
      projectid: new FormControl({ value: this.parentProjectId, disabled: false }, [Validators.required]),
      startdate: new FormControl({ value: item.STARTDATE, disabled: false }, []),
      duedate: new FormControl({ value: item.DUEDATE, disabled: false }, []),
      completionperc: new FormControl({ value: item.COMPLETIONPERC, disabled: false }, []),
      notes: new FormControl({ value: item.NOTES, disabled: false }, []),
    });

    this.popupSummaryTask = true;
  }

  limpiarmodalTask() {
    $('#btnlimpiarmodaltask').click();
  }

  saveUpdateSummary() {
    let value = this._formSummary.value;

    if (!value.name) {
      this.toast.warning(this.translate.instant('msgSummName'));
      return;
    }

    value.projectid = this.parentProjectId;
    value.startdate = value.startdate ? this.pipeDate.transform(value.startdate, 'yyyyMMdd HH:mm:ss') : this.pipeDate.transform(new Date(), 'yyyyMMdd HH:mm:ss');
    value.duedate = value.duedate ? this.pipeDate.transform(value.duedate, 'yyyyMMdd HH:mm:ss') : this.pipeDate.transform(new Date(), 'yyyyMMdd HH:mm:ss');
    value.completionperc = value.completionperc / 100;

    this.taskService.GeneralService({
      id: value.id,
      taskname: value.name,
      startdate: value.startdate,
      duedat: value.duedate,
      percentcomp: value.completionperc,
      sort: value.sort,
      nots: value.notes,
      projectid: this.project.projectid,
      // userid:value.id
      deleted: 0,
      method: "SaveTaskParentInfo"
    }).subscribe(result => {
      // this.taskService.UpdateSummaryTask(value).subscribe(result => {
      // if (result[0].ResultID > 0) {

      this.toast.success(this.translate.instant('msgTaskSuccUpd'));
      this.popupSummaryTask = false;
      this.getSummaryTask(true);
      // this.getTask();
      // }
    });
  }

  onSubmitTask(visibleModal) {
    this.popupTask = visibleModal;
    // this.setGrid2();
    this.getTaksGrid()
  }

  getTask() {
    $("#btntask").click();
  }

  deleteSummary() {
    this.taskService.DeleteSummaryTask(this.summaryToDeleteId).subscribe(result => {
      if (result.length > 0) {
        this.toast.success(this.translate.instant('msgSumTaskInfDelSucc'));
        this.getSummaryTask(true);
        // this.getTask();
        this.popupDeleteSummaryTask = false;
      }
    })
  }

  importMemorizeTosummary: boolean = false
  onItemClick(ev) {
    if (ev.itemData.id == 1) {
      this.popupSummaryTask = true;
    } else if (ev.itemData.id == 2) {
      this.popupTask = true;
    } else if (ev.itemData.id == 3) {
      this.popupImportMemorizedTask = true;
      this.importMemorizeTosummary = false
      this.getMemorizeTasks();
    } else if (ev.itemData.id == 4) {
      this.popupImportFromExcel = true;
    } else if (ev.itemData.id == 5) {
      this.popupImportSummaryFromExcel = true;
    } else if (ev.itemData.id == 6) {
      this.popupImportMemorizedTask = true;
      this.importMemorizeTosummary = true
      this.getMemorizeTasks2();
    }
  }

  openNewTask() {
    this.popupTask = true;
  }

  test(test) {
  }

  getSummaryTask(reload?) {
    // if(this.summaryTask.length==0 || reload){
    this.taskService.GetSummaryTask(this.parentProjectId).subscribe(result => {
      this.summaryTask = result;
    });
    // }
  }

  updateProjectInfo(item) {
    if (item.selectedItem.ID) {
      this._formNewTask.get('projectid').setValue(item.selectedItem.ID);
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }
  //SP_API_Flex_Get_EstimatesSystemProgramDetailAll
  //SP_API_Flex_Get_AreaSystemAll
  //SP_API_Flex_Get_Task_AllByProjectId

  openSWOEdit(swoid) {
    this.router.navigateByUrl('/editSWO');
  }

  clearFilter() {

    this.filterPagedTask = {
      pageindex: 1,
      pagesize: 20,
      orderid: 1,
      summarytaskid: 0,
      projectnumber: '',
      taskname: '',
      responsiblesids: '',
      statusids: '',
      categoryids: '',
      duedate: '',
      taskid: 0,
      projectname: '',
      resourceids: '',
      priorityids: '',
      phaseids: '',
      projectid: this.parentProjectId
    };

    this.taskresourcesText = '';

    this.resourcesText = '';

    this.taskstatusText = '';

    this.categoriesText = '';

    this.get(true);
  }

  syncTreeViewSelection(e) {
    var component = (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (component._userOptions.noDataText == 'No resources to display') {
      if (!this.resourcesText) {
        component.unselectAll();
      }
    }

    if (component._userOptions.noDataText == 'No categories to display') {
      if (!this.categoriesText) {
        component.unselectAll();
      }
    }

    if (component._userOptions.noDataText == 'No responsible to display') {
      if (!this.responsibleText) {
        component.unselectAll();
        // this.taskresponsiblesValues = '';
      }
    }

    if (component._userOptions.noDataText == 'No status to display') {
      if (!this.taskstatusText) {
        component.unselectAll();
      }
    }
  }

  treeView_itemSelectionChanged(e) {
    var nodes = e.component.getNodes();
    var nodesSelectedValue = '';
    var nodesSelectedText = '';
    nodes.forEach(function eachNode(node) {
      if (node.selected == true) {
        nodesSelectedText = nodesSelectedText + node.text + ',';
        nodesSelectedValue = nodesSelectedValue + node.key + ',';
      }
    })

    if (e.component._userOptions.noDataText == 'No resources to display') {
      this.resourcesText = nodesSelectedText;
    }
    if (e.component._userOptions.noDataText == 'No categories to display ') {
      this.categoriesText = nodesSelectedText;
    }
    if (e.component._userOptions.noDataText == 'No status to display') {
      this.taskstatusText = nodesSelectedText;
    }

    if (e.component._userOptions.noDataText == 'No responsible to display') {
      this.responsibleText = nodesSelectedText;
      // this.taskresponsiblesValues = nodesSelectedValue;
      this._formEntity.get('resources').setValue(nodesSelectedValue);
    }

  }

  setGrid2() {
    let mythis = this;
    this.dsPagedTask = AspNetData.createStore({
      key: "ID",
      loadUrl: this.taskService.GetPagedTasksUrl(),
      onBeforeSend: function (e, ajaxOptions) {
        ajaxOptions.method = 'POST';
        mythis.filterPagedTask.pageindex = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
        if (!Number.isInteger(mythis.filterPagedTask.pageindex)) {
          mythis.filterPagedTask.pageindex = 1;
        }
        ajaxOptions.data = JSON.stringify(mythis.filterPagedTask);
        ajaxOptions.contentType = 'application/json';
        ajaxOptions.headers = {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      },
      onUpdated: function (key, values) {
        console.clear();
      },
      onLoading: function (loadoptions) {

      },
      onLoaded: function (data) {
        const grouped = mythis.agruparItems(data);

        return grouped;
        // data = grouped;
        // mythis.dsPagedTask = grouped;
      }
    });
    this.loading = false;
  }

  agruparItems(array = []) {
    let groupItems = [];
    const source = from(array);
    // group by code
    const example = source.pipe(
      groupBy((item: any) => item.SUMMARYTASKNAME),
      // return each item in group as array
      mergeMap(group => group.pipe(toArray()))
    );

    let contador = 0;
    const subscribe = example.subscribe(val => {
      let obj = {
        key: val[0].SUMMARYTASKNAME,
        items: val
      }
      groupItems[contador] = obj;
      contador++;
    });

    return groupItems;
    // this.subTotal = this.bagService.calcularTotal();
  }

  get(isFilter = false) {

    if (this.loading == true) { return 0; }

    if (isFilter == true) {
      this.filterPagedTask.pageindex = 1;

      this.filterPagedTask.responsiblesids = this.taskresponsiblesValues.join(',');
      this.filterPagedTask.statusids = this.taskstatusValues.join(',');
      this.filterPagedTask.categoryids = this.categoriesValues.join(',');
      this.filterPagedTask.resourceids = this.taskresourcesValues.join(',');
      this.filterPagedTask.priorityids = '';

    }


    this.loading = true;
    localStorage.setItem('filterPagedTask', JSON.stringify(this.filterPagedTask));

    console.clear();
    // this.setGrid2();
    // this.getTask();

  }

  openTaskEdit(taskid) {
    this.router.navigateByUrl(`/taskManagement/editTask/${taskid}/${this.parentProjectId > 0}`);
  }

  openProjectEdit(projectid, projectnumber) {
    this.router.navigateByUrl(`/editSales/${projectnumber}/${projectid}`);
  }

  // Modal Grid Summary Task

  mdSummaryTask() {
    this.initFormSummaryTask();
    this.getSummaryTask(true);
    this.popupGridSummaryTask = true;
  }

  //Modal Edit Multiple Tasks

  mdEditTasks() {
    if (this.categorySelect.length == 0) {
      this.taskService.GetTaskCategories().subscribe(result => {
        this.categorySelect = result;
      });
    }
    if (this.statusSelect.length == 0) {
      this.taskService.GetTaskStatus().subscribe(result => {
        this.statusSelect = result;
      });
    }
    if (this.prioritySelect.length == 0) {
      this.taskService.GetTaskPriorities().subscribe(result => {
        this.prioritySelect = result;
      });
    }
    if (this.employeeSelect == 0) {
      this.taskService.GetTaskEmployees().subscribe(result => {
        this.employeeSelect = result;
      });
    }

    this.getSummaryTask();

    this.popupEditTask = true;
    this.rowSelectedTask = [];
    this.rowSelectedTask = this.TasksGrid.instance.getSelectedRowsData();
    this.setEditForm();
  }

  setEditForm() {
    this.editTasks = new FormGroup({
      responsibleid: new FormControl('', []),
      resourceArray: new FormControl('', []),
      categoryid: new FormControl('', []),
      priorityid: new FormControl('', []),
      statusid: new FormControl('', []),
      completionperc: new FormControl(0, []),
      sort: new FormControl('', []),
      area: new FormControl('', []),
      summarytaskid: new FormControl('', []),
    })
  }

  selectionChanged(data) {
    this.rowSelectedTask = this.TasksGrid.instance.getSelectedRowsData();
    // this.selectedRows = true;
    if (this.rowSelectedTask.length >= 1) {
      this.selectedRows = true;
    } else { this.selectedRows = false; }
  }

  updateTasks() {
    let form = this.editTasks.value;

    this.rowSelectedTask.forEach(async (task, i) => {
      form.responsibleid == "" ? this.task.employeeid = task.EMPLOYEEID : this.task.employeeid = form.responsibleid;
      if (form.resourceArray == "") {
        this.task.taskresources = task.resourcesIDs
      } else {
        console.log(task.resourcesIDs);

        if (task.resourcesIDs == null) {
          this.task.taskresources = form.resourceArray.join(',');
        } else {
          let arr = task.resourcesIDs.split(',');
          arr.push(form.resourceArray);
          this.task.taskresources = arr.join(',');
        }
      }
      task.COMPLETIONPERC = form.completionperc !== 0 ? form.completionperc / 100 : task.COMPLETIONPERC / 100;

      form.statusid == "" ? this.task.statusid = task.STATUSID : this.task.statusid = form.statusid;
      if (form.statusid == 3) { this.task.completionperc = 1; } else { this.task.completionperc = task.COMPLETIONPERC; }
      form.categoryid == "" ? this.task.todocategoryid = task.TODOCATEGORYID : this.task.todocategoryid = form.categoryid;
      form.priorityid == "" ? this.task.priorityid = task.PRIORITYID : this.task.priorityid = form.priorityid;
      form.summarytaskid !== "" ? this.task.summarytaskid = form.summarytaskid : this.task.summarytaskid = task.summarytaskid;
      this.task.sort = form.sort !== "" ? form.sort : task.order;

      this.task.area = form.area !== "" ? form.area : task.area;
      task.LOCATIONID == null ? this.task.locationid = 0 : this.task.locationid = task.LOCATIONID;
      task.PHASEID == null ? this.task.phaseid = 0 : this.task.phaseid = task.PHASEID;
      task.VENDORID == null ? this.task.vendorid = 0 : this.task.vendorid = task.VENDORID;
      this.task.estimatedcost = task.estimatecost;
      // this.task.sort = task.order;
      this.task.name = task.TASKNAME;
      this.task.notes = task.notes;
      this.task.completiondate = task.COMPDATE ? this.pipeDate.transform(task.COMPDATE, 'yyyyMMdd hh:mm:ss') : '';
      this.task.duedate = task.DUEDATE ? this.pipeDate.transform(task.DUEDATE, 'yyyyMMdd hh:mm:ss') : '';
      this.task.estimatedtime = task.ESTIMATEDTIME;
      this.task.resources = this.task.taskresources;
      this.task.vendorid = task.VENDORID;
      this.task.taskid = task.ID;
      this.task.projectid = task.PROJECTID;
      this.task.startdate = task.StartDate ? this.pipeDate.transform(task.StartDate, 'yyyyMMdd hh:mm:ss') : '';
      this.task.method = 'Insert_Task_ce';
      this.taskService.updateTask2(this.task).subscribe(result => {
        if (this.rowSelectedTask.length == i + 1) {
          this.toast.success(this.translate.instant('msgTasUpdSucc'));
          this.popupEditTask = false;
          this.getTaksGrid();
        }
      })
    });

  }

  deleteTask(id) {
    this.taskService.DeleteTask(id).subscribe(result => {
      this.getTaksGrid();
      this.toast.success(this.translate.instant('msgTaskInfoDelSucc'));
      this.showpopupDeleteTask = false;
    })
  }

  popupDeleteTask(data) {
    this.selectedTaskId = data.ID;
    this.showpopupDeleteTask = true;
  }

  duplicateTask(id) {
    this.taskService.DuplicateTaskGrid(id).subscribe(result => {
      this.toast.success(this.translate.instant('msgInfoDupSucc'));
      this.getTaksGrid();
      // this.showpopupDuplicateTask = false;
    })
  }

  popupDuplicateTask(data) {
    this.selectedTaskId = data.ID;
    this.showpopupDuplicateTask = true;
  }

  //Import Memorize Task
  getMemorizeTasks() {
    this.taskService.Get_ProjectTodoMemorized(this.project).subscribe(result => {
      this.dataSummaryMemorizeTask = result;
    })

    // this.taskService.Get_ProjectTodoSummaryMemorized(this.project).subscribe(result=>{
    //   this.dataSummaryMemorizeTask = result;
    // })
  }

  getMemorizeTasks2() {
    // this.taskService.Get_ProjectTodoMemorized(this.project).subscribe(result=>{
    //   this.dataMemorizeTask = result;
    // })

    this.taskService.Get_ProjectTodoSummaryMemorized(this.project).subscribe(result => {
      this.dataSummaryMemorizeTask = result;
    })
  }

  formatDuration(DURATION) {
    let durat = DURATION ? DURATION.toString().split('.') : ['', ''];
    durat[0] = durat[0] ? durat[0].substr(0, 2).padStart(2, '0') : '00';
    durat[1] = durat[1] ? durat[1].substr(0, 2).padEnd(2, '0') : '00';

    return durat[0] + ':' + durat[1];
  }

  ImportSelectionChanged(data) {
    this.rowSelectedMemorizeTasks = this.MemorizeTasksGrid.instance.getSelectedRowsData();

    if (this.rowSelectedMemorizeTasks.length >= 1) {
      this.disableImport = false;
    } else { this.disableImport = true; }
  }

  prepareRowPart(info) {
    if (info.rowType === "data") {
      if (info.data.MILESTONEID2 == 1) {
        info.rowElement.style.backgroundColor = "#e6c7a7";
      }
    }
  }

  importMemorize() {
    let array = []

    this.rowSelectedMemorizeTasks.forEach((element, i) => {
      array.push(element.ID);
      if (this.rowSelectedMemorizeTasks.length == i + 1) {
        let ids;
        if (array) { ids = array.join(','); }
        let obj
        if (this.importMemorizeTosummary) {
          obj = { method: 'SaveTaskParentInfo', projectid: this.project.projectid, taskname: element.NAME, deleted: 0, id: 0, sort: element.SEQUENCE3 };
        } else {
          obj = { method: 'Insert_ProjectMemorizedTaskCEByMemorizedIdsCE', projectid: this.project.projectid, memorizedtaskids: ids };
        }

        this.taskService.GeneralService(obj).subscribe(result => {

          this.toast.success(this.translate.instant('msgMemTaskImpSucc'));
          this.popupImportMemorizedTask = false;
          this.rowSelectedMemorizeTasks = [];
          this.MemorizeTasksGrid.instance.clearSelection();
          this.getTaksGrid();
        })
      }
    });
  }

  mdGanttView() {
    // this.router.navigateByUrl(`/ganttScheduler/${this.parentProjectId}`);
    this.router.navigate(['/ganttScheduler'], { queryParams: { projectid: this.parentProjectId } });
  }
  task2: any = {
    taskid: '', name: '', projectid: '', employeeid: '', taskresources: '',
    statusid: '', todocategoryid: '', priorityid: '', area: '', phaseid: '', estimatedcost: '',
    startdate: '', estimatedtime: '', duedate: '', completionperc: '', completiondate: '',
    notes: '', sort: '', locationid: '', vendorid: '', SUMMARYTASKID: '',
    resources: '', createon: '', method: 'Insert_Task_ce'
  }

  updatePercent(e) {
    let task = e.oldData;
    this.task2.employeeid = e.oldData.EMPLOYEEID;
    this.task2.taskresources = task.resourcesIDs;
    this.task2.statusid = task.STATUSID;

    if (e.newData.COMPLETIONPERC != undefined) {
      this.task2.completionperc = Number(e.newData.COMPLETIONPERC) / 100;
    } else {
      this.task2.completionperc = Number(e.oldData.COMPLETIONPERC) / 100;
    }

    // *************
    this.task2.todocategoryid = task.TODOCATEGORYID;
    this.task2.priorityid = task.PRIORITYID;
    this.task2.area = task.area;
    this.task2.locationid = task.LOCATIONID;
    this.task2.phaseid = task.PHASEID;
    this.task2.vendorid = task.VENDORID;
    this.task2.estimatedcost = task.estimatecost;
    this.task2.summarytaskid = task.summarytaskid;

    if (e.newData.order != undefined) {
      this.task2.sort = e.newData.order;
    } else {
      this.task2.sort = e.oldData.order;
    }

    this.task2.name = task.TASKNAME;
    this.task2.notes = task.notes;
    this.task2.completiondate = task.COMPDATE;
    // this.task2.duedate = task.DUEDATE;
    this.task2.duedate = task.DUEDATE ? this.pipeDate.transform(task.DUEDATE, 'yyyyMMdd hh:mm:ss') : '';
    this.task2.startdate = task.StartDate ? this.pipeDate.transform(task.StartDate, 'yyyyMMdd hh:mm:ss') : '';
    this.task2.estimatedtime = task.ESTIMATEDTIME;
    this.task2.resources = this.task2.taskresources;
    this.task2.vendorid = task.VENDORID;
    this.task2.taskid = task.ID;
    this.task2.projectid = task.PROJECTID;
    this.task2.method = 'Insert_Task_ce';
    // this.task2.taskid = e.oldData.ID
    this.taskService.updateTask2(this.task2).subscribe(result => {
      this.toast.success(this.translate.instant('msgTasUpdSucc'));
      this.getTaksGrid();
    })
  }

  deleteMultipleTask() {
    this.rowSelectedTask.forEach((task, i) => {
      this.taskService.DeleteTask(task.ID).subscribe(result => {
        if (this.rowSelectedTask.length == i + 1) {
          this.toast.success(this.translate.instant('msgTaskInfoDelSucc'));
          this.showpopupDeleteMultipleTask = false;
          this.popupEditTask = false;
          this.getTaksGrid();
          this.rowSelectedTask = [];
        }
      })
    })
  }

  test2(notes) {
  }

  expandFilter() {
    if (this.statusSelect.length == 0) {
      this.taskService.GetTaskStatus().subscribe(result => {
        this.statusSelect = result;
        this.popupFilter = true;
        // this.statuses = [1,2];
      });
    } else {
      this.popupFilter = true;
    }

    this.cancelButtonFilter = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupFilter = false;
      },
    };

    this.saveButtonFilter = {
      text: 'Filter',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        localStorage.setItem('filterStatus' + this.parentProjectId, this.statuses);
        this.getTaksGrid();
        this.popupFilter = false;
      },
    };
  }

  onOptionChanged(e) {

    if (e.name == "filterValue" && e.value && e.value.length == 0) {
      this.statuses = [];
      localStorage.setItem('filterStatus' + this.parentProjectId, this.statuses);
      this.getTaksGrid();
    }
  }

  CloseopenPopupImport() {
    this.popupImportFromExcel = false;
    this.popupImportSummaryFromExcel = false;
    this.onFileRemove();
  }

  onFileAdd(obj: File) {
    if (obj[0] != undefined) {
      this.loadingService.isLoading.next(true);
      /* wire up file reader */
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true });






        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];



        /* save data */
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        data = data.filter(x => x.length > 0);
        this.fileData = data;
        this.dataFormatted.headers = data[0];

        let dataFormateada = this.arrayToJSONObject(data);
        let infoFinal = []
        if (dataFormateada.length != 0) {
          dataFormateada.forEach(element => {
            infoFinal.push(element)
          })

          this.dataFormatted.data = infoFinal;
        }
        // this.validateFile();
      };
      reader.readAsBinaryString(obj[0]);
      this.loadingService.isLoading.next(false);
    }
  }

  onFileRemove() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.valueDocument = []
  }

  uploadFile() {
    let data = this.gridfile.instance.getVisibleRows().map(x => x.data);

    let contador = 0;

    this.taskService.GetTaskEmployees().subscribe(responsibles => {
      this.taskService.GetSummaryTask(this.parentProjectId).subscribe(summaryTaks => {
        this.taskService.GetTaskCategoriesFlex().subscribe(categories => {

          for (const element of data) {

            const Category_id = categories.find(({ ID }) => ID == element.Category_id);

            const Summary_id = summaryTaks.find(({ ID }) => ID == element.Summary_id);

            const Reponsible_id = responsibles.find(({ ID }) => ID == element.Reponsible_id);

            if (Category_id == undefined && element.Category_id != 0) {
              this.toast.warning("The Category ID does not exist");
              return false;
            }

            if (Summary_id == undefined && element.Summary_id != 0) {
              this.toast.warning("The Summary ID does not exist");
              return false;
            }

            if (Reponsible_id == undefined && element.Reponsible_id != 0) {
              this.toast.warning("The Responsible ID does not exist");
              return false;
            }


            if (element.Name === undefined || element.Name === "" || element.Name == null) {
              this.toast.warning("The Name cannot be empty (you can put New Task instead)");
              return false;
            }

            if (element.Priority !== undefined && !Number.isInteger(element.Summary_id || element.Category_id || element.Reponsible_id)) {
              this.toast.warning("Please verify that Summary, Responsible or Category is a valid ID");
              return false;
            }

            if (!Number.isInteger(element.Sort)) {
              this.toast.warning("The Sort must be an integer)");
              return false;
            }
          }

          for (const element of data) {
            let priority = element.Priority.toLowerCase();

            if (priority == 'high' || priority == 'High') {
              priority = 1;
            } else if (priority == 'low' || priority == 'Low') {
              priority = 3;
            } else if (priority == 'normal' || priority == 'Normal') {
              priority = 2;
            } else {
              this.toast.warning('Please verify that the priority is one of these "High, Low, Normal"');
              return false;
            }

            let newInfo = {
              notes: element.Notes,
              categoryid: element.Category_id,
              priorityid: priority,
              summarytaskid: element.Summary_id,
              duedate: element.Due_Date,
              startdate: element.Start_Date,
              reponsibleid: element.Reponsible_id,
              sort: element.Sort,
              area: element.Area,
              name: element.Name,
              duration: element.Duration,
              projectid: Number(this.parentProjectId),
              taskid: 0,
              method: "Import_Task"
            };


            this.MapInformationService.SaveInfoSites(newInfo)
              .subscribe(resp => {
                contador++
                if (contador == data.length) {
                  this.toast.success("Information successfully uploaded");
                  // this.onFileRemove();
                  this.CloseopenPopupImport();
                  this.getTaksGrid();
                }
              }, error => {
                this.toast.warning("An error has occurred check the header and structure of the excel")
              })
          }
        });
      })
    })

  }

  uploadFileSummary() {
    let data = this.gridFileSummary.instance.getVisibleRows().map(x => x.data);

    let contador = 0;

    data.forEach(element => {
      if (element.Name === undefined || element.Name === "" || element.Name == null) {
        this.toast.warning("The Name cannot be empty (you can put New Summary instead)");
      }

      let newInfo = {
        notes: element.Notes,
        duedate: element.Due_Dates,
        startdate: element.Start_Date,
        sort: element.Sort,
        name: element.Name,
        projectid: Number(this.parentProjectId),
        id: 0,
        method: "Import_SummaryTask"
      };


      this.MapInformationService.SaveInfoSites(newInfo)
        .subscribe(resp => {
          contador++
          if (contador == data.length) {
            this.toast.success("Information successfully uploaded");
            this.CloseopenPopupImport();
            this.getTaksGrid();
          }
        }, error => {
          this.toast.warning("An error has occurred check the header and structure of the excel")
        })
    })
  }

  arrayToJSONObject(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  collased: boolean = false

  closeParents() {
    this.TasksGrid.instance.collapseAll()
    this.collased = true
  }

  calculateSelectedRow(options) {
    console.log("🚀 ~ file: task-list.component.ts:1498 ~ calculateSelectedRow ~ options:", options)
    let found = this.taskDataSource.find((x) => x.SUMMARYTASKNAME === options.value);
    console.log("🚀 ~ file: task-list.component.ts:1500 ~ calculateSelectedRow ~ found:", found)
    if (found != undefined) {
      return " " + found.TOTALSUMMARY;
    }
  }

  OpenParents() {
    this.TasksGrid.instance.expandAll()
    this.collased = false
  }

  customizeColumns(columns) {
    let result = localStorage.getItem('TasksGrid');

    if (result) {
      let data = JSON.parse(result);

      let finalColumns = columns.map((col, i) => {
        // data[i].name ? col.caption = data[i].name : '';
        data[i].dataField ? col.dataField = data[i].dataField : '';
        data[i].dataType ? col.dataType = data[i].dataType : '';
        col.visible = data[i].visible;
        col.visibleIndex = data[i].visibleIndex;
        data[i].width ? col.width = data[i].width : '';
        return col;
      });
      return finalColumns
    }
  }

  saveState1 = (state) => {


    let extraconfig = {
      collased: this.collased == true ? 1 : 0
    }

    if (this.actualState == 0) {
      this.ProjectService.InsertUpdateGridConfiguration(0, this.gridId, state.filterValue, JSON.stringify(state.columns), JSON.stringify(extraconfig)).subscribe(result => {
        return state;
      })
    } else if (this.actualState.ID) {
      this.ProjectService.InsertUpdateGridConfiguration(this.actualState.ID, this.gridId, state.filterValue, JSON.stringify(state.columns), JSON.stringify(extraconfig)).subscribe(result => {
        return state;
      })
    }
  }

  customizeText(data, reload) {
    if (data.value != undefined) {

      let item = data.value.toFixed(2)
      let visibleData = this.TasksGrid.instance.getVisibleRows().map(x => x.data);
      if (item.includes('.')) {
        // if (localStorage.getItem("SumaHora") != undefined){
        if (visibleData) {
          // let infoGrid = JSON.parse(localStorage.getItem("SumaHora"));
          let infoGrid = visibleData;
          let hour
          let minute
          let second
          let a = [0, 0]
          if (infoGrid.length > 0) {
            infoGrid.forEach(element => {
              if (element.duration != undefined) {
                let hora = element.duration.toString().split(':')[0]
                let minuto = element.duration.toString().split(':')[1]

                if (minuto != undefined) {
                  if (minuto.length == 1) {
                    minuto = minuto + "0"
                  }
                } else {
                  minuto = "00"
                }
                a[0] += parseInt(hora)
                a[1] += parseInt(minuto)
              }
            });
          }

          let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;

          hour = Math.floor(seconds / 3600);
          hour = (hour < 10) ? '0' + hour : hour;
          minute = Math.floor((seconds / 60) % 60);
          minute = (minute < 10) ? '0' + minute : minute;
          second = seconds % 60;
          second = (second < 10) ? '0' + second : second;

          // localStorage.removeItem("SumaHora")
          return hour + ':' + minute
          // }
        }
      }
    }
  }

  customizeText2(data, reload) {
    if (data.value != undefined) {

      let item = data.value.toFixed(2)
      let visibleData = this.TasksGrid.instance.getVisibleRows().map(x => x.data);
      if (item.includes('.')) {
        // if (localStorage.getItem("SumaHora") != undefined){
        if (visibleData) {
          // let infoGrid = JSON.parse(localStorage.getItem("SumaHora"));
          let infoGrid = visibleData;
          let hour
          let minute
          let second
          let a = [0, 0]
          if (infoGrid.length > 0) {
            infoGrid.forEach(element => {
              if (element.ActualHours != undefined) {
                let hora = element.ActualHours.toString().split(':')[0]
                let minuto = element.ActualHours.toString().split(':')[1]

                if (minuto != undefined) {
                  if (minuto.length == 1) {
                    minuto = minuto + "0"
                  }
                } else {
                  minuto = "00"
                }
                a[0] += parseInt(hora)
                a[1] += parseInt(minuto)
              }
            });
          }

          let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;

          hour = Math.floor(seconds / 3600);
          hour = (hour < 10) ? '0' + hour : hour;
          minute = Math.floor((seconds / 60) % 60);
          minute = (minute < 10) ? '0' + minute : minute;
          second = seconds % 60;
          second = (second < 10) ? '0' + second : second;

          // localStorage.removeItem("SumaHora")
          return hour + ':' + minute
          // }
        }
      }
    }
  }

}
